module.exports = __webpack_public_path__ + "media/images/flags/64/Central-African-Republic-582180874c99f56045c8033ab192e3df.png";